// Testing configuration
export const TESTING_CONFIG = {
  // Email addresses that have access to developer tools
  testingEmails: [
    'test@goalmint.com',
    'dev@goalmint.com', 
    'admin@goalmint.com',
    'your-test-email@gmail.com', // Replace with your actual testing email
    'chido@example.com', // Add your email here
    'joy@gmail.com', // Added developer account
    'mike@gmail.com', // Added developer account
    'chidimike@ymail.com', // Added test account
  ] as string[],
  
  // Development settings
  development: {
    // Enable developer tools for all users in development mode
    enableForAllInDev: false, // Changed to false - only test accounts get access
    // Enable developer tools for specific user IDs
    testingUserIds: [] as string[],
  }
};

// Check if user has access to developer tools
export const hasDeveloperAccess = (email?: string | null, userId?: string | null): boolean => {
  // Check if user email is in testing list (primary check)
  if (email && TESTING_CONFIG.testingEmails.includes(email.toLowerCase())) {
    return true;
  }
  
  // Check if user ID is in testing list
  if (userId && TESTING_CONFIG.development.testingUserIds.includes(userId)) {
    return true;
  }
  
  // Only allow all users in development mode if explicitly enabled
  if (TESTING_CONFIG.development.enableForAllInDev && __DEV__) {
    return true;
  }
  
  return false;
};

// Get testing account info for display
export const getTestingAccountInfo = (email?: string | null): string | null => {
  if (!email) return null;
  
  const isTesting = TESTING_CONFIG.testingEmails.includes(email.toLowerCase());
  if (isTesting) {
    return `Testing Account: ${email}`;
  }
  
  return null;
}; 

export const IS_TESTING = __DEV__ || process.env.NODE_ENV === 'development';

export const BILLING_CONFIG = {
  enableTestMode: IS_TESTING,
  testProductIds: [
    'android.test.purchased',
    'android.test.canceled', 
    'android.test.refunded',
    'android.test.item_unavailable'
  ],
  // Real product IDs that should match your Google Play Console
  realProductIds: [
    'standard_monthly',
    'standard_yearly', 
    'premium_monthly',
    'premium_yearly'
  ]
};

export const TEST_SUBSCRIPTION_DATA = {
  standard_monthly: {
    id: 'standard_monthly',
    tier: 'standard',
    price: 4.99,
    currency: 'USD',
    billingPeriod: 'monthly',
    description: 'Standard Plan (Monthly) - Test Mode'
  },
  standard_yearly: {
    id: 'standard_yearly',
    tier: 'standard',
    price: 49.99,
    currency: 'USD',
    billingPeriod: 'yearly',
    description: 'Standard Plan (Yearly) - Test Mode'
  },
  premium_monthly: {
    id: 'premium_monthly',
    tier: 'premium',
    price: 9.99,
    currency: 'USD',
    billingPeriod: 'monthly',
    description: 'Premium Plan (Monthly) - Test Mode'
  },
  premium_yearly: {
    id: 'premium_yearly',
    tier: 'premium',
    price: 99.99,
    currency: 'USD',
    billingPeriod: 'yearly',
    description: 'Premium Plan (Yearly) - Test Mode'
  }
}; 